import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes, JSX } from 'react';
import { cn } from '@/lib/utils';

const alertVariants = cva('relative w-full rounded-md border px-4 py-3 text-sm grid grid-cols-[0_1fr] gap-y-1 has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] has-[>svg]:gap-x-3', {
  variants: {
    variant: {
      default: 'bg-card text-card-foreground border-border',
      orange: 'bg-amber-50 text-amber-900 border-amber-300 [&>svg]:text-amber-600',
      red: 'bg-destructive/10 text-destructive border-destructive/30 [&>svg]:text-destructive',
    },
  },
  defaultVariants: { variant: 'default' },
});

export interface AlertProps extends HTMLAttributes<HTMLDivElement>, VariantProps<typeof alertVariants> {}

export function Alert({ className, variant, ...props }: AlertProps): JSX.Element {
  return <div data-slot="alert" role="alert" className={cn(alertVariants({ variant }), className)} {...props} />;
}

export function AlertTitle({ className, ...props }: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div data-slot="alert-title" className={cn('col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight', className)} {...props} />;
}

export function AlertDescription({ className, ...props }: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return <div data-slot="alert-description" className={cn('col-start-2 grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed', className)} {...props} />;
}
